
import axios from 'axios'
import MyGlobal from '@/components/base/Global'
import { Message } from 'element-ui'
import router from '../router'
import utils from '../utils/index.js'

import { i18n } from '../lang/i18n.js'
const api = require('../axios/request')
// axios.defaults.baseURL ='http://192.168.1.118:9090'
// axios.defaults.baseURL ='http://192.168.1.199:9090'
// axios.defaults.baseURL ='http://192.168.1.141:9444'
// axios.defaults.baseURL ='http://192.168.1.107:9444/interface'
// axios.defaults.baseURL ='http://basf.bevol.cn/interface'
// axios.defaults.baseURL ='http://dlite3-report.basf.com:9444/interface'
axios.defaults.baseURL = 'https://dlite3-report.basf.com:9543/interface'
axios.defaults.timeout = 6000000

export const uploadFile = ({ state }, file) => {
  axios.post('/FileUpload', file, {
    headers: {
      'Content-Type': 'multipart/form-data'
    }
  })
    .then(response => {
      console.log('uploadHeadImg', response)
      let data = response.data
      if (data.errCode == 'success') {
        // var arr = data.fileName.split('.')
        // arr[arr.length-1] = arr[arr.length-1].toUpperCase()
        // var fileName = arr.join('.') + "?" + new Date().getTime()
        var fileName = data.fileName + '?' + new Date().getTime()
        state.userInfo = {...JSON.parse(sessionStorage.userInfo), headImg: utils.baseUrl + 'usertx/' + fileName}
        sessionStorage.userInfo = JSON.stringify(state.userInfo)
        console.log(sessionStorage.userInfo)
      }
    })
}

/**
 * boss----------------------
 */

export const selectBossPopUpParamsAction = ({state, commit}, data) => {
  commit('changeLoadingState', {pn: 'selectBossPopUpParams', s: true})
  commit('setLoginId', state.selectBossPopUpParams)
  console.log('selectBossPopUpParams', state.selectBossPopUpParams)
  axios.post('/CallMethod', state.selectBossPopUpParams)
    .then((response) => {
      commit('changeLoadingState', {pn: 'selectBossPopUpParams', s: false})
      console.log('selectBossPopUpParamsAction', response)
      let data = response.data
      if (data.errorCode == MyGlobal.errorCode) {
        state.bevolBrands = data.data.bevolBrands
        state.brndPostnsFirst = data.data.brndPostnsFirst
        state.pricePostns = data.data.pricePostns
      }
    })
    .catch((err) => {
      commit('changeLoadingState', {pn: 'selectBossPopUpParams', s: false})
      console.log(err)
      Message({
        type: 'error',
        message: 'Network error, please try again',
        showClose: true
      })
    })
}

// selectProductClaimTop10
export const selectProductClaimTop10Action = ({state, commit}, data = {}) => {
  state.prdctClaimTop10s = []
  commit('changeLoadingState', {pn: 'selectProductClaimTop10Params', s: true})
  commit('setSelectData', {pn: 'selectProductClaimTop10Params', d: data})
  console.log('selectProductClaimTop10Params', state.selectProductClaimTop10Params)
  axios.post('/CallMethod', state.selectProductClaimTop10Params)
    .then((response) => {
      commit('changeLoadingState', {pn: 'selectProductClaimTop10Params', s: false})
      console.log('selectProductClaimTop10Action', response)
      let data = response.data
      if (data.errorCode == MyGlobal.errorCode) {
        state.prdctClaimTop10s = data.data.prdctClaimTop10s
      }
    })
    .catch((err) => {
      state.prdctClaimTop10s = []
      commit('changeLoadingState', {pn: 'selectProductClaimTop10Params', s: false})
      console.log(err)
      Message({
        type: 'error',
        message: 'Network error, please try again',
        showClose: true
      })
    })
}

// 获取最近浏览的5个产品数据
export const selectLastestFiveProductParamsAction = ({state, commit}) => {
  commit('changeLoadingState', {pn: 'selectLastestFiveProductParams', s: true})
  commit('setLoginId', state.selectLastestFiveProductParams)
  console.log('selectLastestFiveProductParams', state.selectLastestFiveProductParams)
  axios.post('/CallMethod', state.selectLastestFiveProductParams)
    .then((response) => {
      commit('changeLoadingState', {pn: 'selectLastestFiveProductParams', s: false})
      console.log('selectLastestFiveProductParamsAction', response)
      let data = response.data
      if (data.errorCode == MyGlobal.errorCode) {
        state.prdctBeans = data.data.prdctBeans
      }
    })
    .catch((err) => {
      commit('changeLoadingState', {pn: 'selectLastestFiveProductParams', s: false})
      console.log(err)
      Message({
        type: 'error',
        message: 'Network error, please try again',
        showClose: true
      })
    })
}

// selectOrderDetail
export const selectOrderDetailAction = ({state, commit}, data = {}) => {
  commit('changeLoadingState', {pn: 'selectOrderDetailParams', s: true})
  commit('setLoginId', state.selectOrderDetailParams)
  commit('setSelectData', {pn: 'selectOrderDetailParams', d: data})
  console.log('selectOrderDetailParams', state.selectOrderDetailParams)
  axios.post('/CallMethod', state.selectOrderDetailParams)
    .then((response) => {
      commit('changeLoadingState', {pn: 'selectOrderDetailParams', s: false})
      console.log('selectOrderDetailAction', response)
      let data = response.data
      if (data.errorCode == MyGlobal.errorCode) {
        state.basfOrder = data.data.basfOrder
      }
    })
    .catch((err) => {
      commit('changeLoadingState', {pn: 'selectOrderDetailParams', s: false})
      console.log(err)
      Message({
        type: 'error',
        message: 'Network error, please try again',
        showClose: true
      })
    })
}
// selectOrderList
export const selectOrderListAction = ({state, commit}, data) => {
  commit('changeLoadingState', {pn: 'selectOrderListParams', s: true})
  commit('setLoginId', state.selectOrderListParams)
  console.log('selectOrderListParams', state.selectOrderListParams)
  axios.post('/CallMethod', state.selectOrderListParams)
    .then((response) => {
      commit('changeLoadingState', {pn: 'selectOrderListParams', s: false})
      console.log('selectOrderListAction', response)
      let data = response.data
      if (data.errorCode == MyGlobal.errorCode) {
        state.orderList = data.data.orderList
      }
    })
    .catch((err) => {
      commit('changeLoadingState', {pn: 'selectOrderListParams', s: false})
      console.log(err)
      Message({
        type: 'error',
        message: 'Network error, please try again',
        showClose: true
      })
    })
}

export const brandDshbrdAction = ({state, commit}, data = {}) => {
  commit('changeLoadingState', {pn: 'brandDshbrdParams', s: true})
  commit('setSelectData', {pn: 'brandDshbrdParams', d: data})
  console.log('brandDshbrdParams', state.brandDshbrdParams)
  axios.post('/CallMethod', state.brandDshbrdParams)
    .then((response) => {
      commit('changeLoadingState', {pn: 'brandDshbrdParams', s: false})
      console.log('brandDshbrdAction', response)
      let data = response.data
      if (data.errorCode == MyGlobal.errorCode) {
        state.brandDshbrdDatas = data.data
      }
    })
    .catch((err) => {
      commit('changeLoadingState', {pn: 'brandDshbrdParams', s: false})
      console.log(err)
      Message({
        type: 'error',
        message: 'Network error, please try again',
        showClose: true
      })
    })
}



// WEBPACK FOOTER //
// ./src/store/actions.js